import React from 'react';

const Hero = () => {
  return (
    <section className="bg-black text-white flex flex-col justify-center items-center px-6 py-20">
      <div className="text-center max-w-4xl mx-auto">
      
        <h1 className="text-2xl md:text-4xl font-bold mb-8 tracking-wide" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
          PokéLens.
        </h1>
        
      </div>
    </section>
  );
};

export default Hero;
